"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGroupOwnersForMetricsCategory = exports.getGroupOwnerCandidates = exports.getOwnerLabelForMetricsProperty = exports.getOwnersForMetricsProperty = exports.mockCurrentUser = exports.mockUsers = void 0;
exports.mockUsers = [
    {
        id: 'user-admin-kasia',
        displayName: 'Katherine Adams',
        role: 'admin',
        permissions: [],
    },
    {
        id: 'user-gowner-anna',
        displayName: 'Anna Collins',
        role: 'group-owner',
        permissions: ['benefit.*'],
    },
    {
        id: 'user-gowner-marek',
        displayName: 'Mark Turner',
        role: 'group-owner',
        permissions: [
            'benefit.*',
            'budget.*',
            'data.*',
            'persona.*',
            'tech.*',
        ],
    },
    {
        id: 'user-owner-olivia',
        displayName: 'Olivia Wilson',
        role: 'owner',
        permissions: [
            'benefit.benefit:automated-intelligent-personalized-project-role-recommendations',
            'benefit.benefit:consistency',
            'benefit.benefit:time-saving',
            'persona.persona:delivery-manager',
            'persona.persona:project-manager',
            'data.data:active-directory',
            'data.data:agent-interactions',
            'data.data:annotation',
            'data.data:comment-data',
            'data.data:document-oriented-database',
            'data.data:onedrive',
            'data.data:sharepoint',
            'data.data:employee-skills-experience-profiles',
            'data.data:internal-project-opening',
            'data.data:personnel-information',
            'data.data:timeline',
        ],
    },
    {
        id: 'user-owner-peter',
        displayName: 'Peter Green',
        role: 'owner',
        permissions: [
            'benefit.benefit:enhanced-consistency',
            'benefit.benefit:compliance-and-security',
            'benefit.benefit:user-experience',
            'persona.persona:documentation-specialist',
            'persona.persona:hr-administrator',
            'persona.persona:finance-admin-staff',
            'tech.tech:agent-dtk1oo',
            'tech.tech:application-insights',
            'tech.tech:approval-audit-workflow-system',
            'tech.tech:azure-active-directory',
            'tech.tech:azure-form-recognizer',
            'tech.tech:centrepoint-web-interface',
            'tech.tech:cloud-infrastructure-azure',
            'tech.tech:continuous-integration-and-deployment-pipeline',
            'tech.tech:custom-conversational-interface',
            'tech.tech:document-management-system-integration',
            'tech.tech:document-oriented-database',
            'tech.tech:encrypted-transmission',
            'tech.tech:blob-storage',
            'tech.tech:elasticsearch-logstash-kibana-stack',
            'tech.tech:elk-stack',
            'tech.tech:azure-openai-service',
            'tech.tech:azure-cognitive-services',
            'tech.tech:microsoft-graph-api',
            'tech.tech:secure-enterprise-sso',
        ],
    },
];
exports.mockCurrentUser = exports.mockUsers[3];
var PROPERTY_OWNER_IDS_BY_NORMALIZED_ID = {
    'benefit:time-saving': ['user-owner-olivia'],
    'benefit:consistency': ['user-owner-olivia', 'user-owner-peter'],
    'benefit:enhanced-consistency': ['user-owner-peter'],
    'benefit:user-experience': ['user-owner-peter'],
    'persona:delivery-manager': ['user-owner-olivia'],
    'persona:project-manager': ['user-owner-olivia'],
    'persona:documentation-specialist': ['user-owner-peter'],
    'persona:hr-administrator': ['user-owner-peter'],
    'data:active-directory': ['user-owner-olivia'],
    'data:agent-interactions': ['user-owner-olivia'],
    'data:annotation': ['user-owner-olivia'],
    'data:comment-data': ['user-owner-olivia'],
    'data:document-oriented-database': ['user-owner-olivia'],
    'data:onedrive': ['user-owner-olivia'],
    'data:sharepoint': ['user-owner-olivia'],
    'data:employee-skills-experience-profiles': ['user-owner-olivia'],
    'data:internal-project-opening': ['user-owner-olivia'],
    'data:personnel-information': ['user-owner-olivia'],
    'data:timeline': ['user-owner-olivia'],
    'tech:agent-dtk1oo': ['user-owner-peter'],
    'tech:application-insights': ['user-owner-peter'],
    'tech:approval-audit-workflow-system': ['user-owner-peter'],
    'tech:azure-active-directory': ['user-owner-peter'],
    'tech:azure-form-recognizer': ['user-owner-peter'],
    'tech:centrepoint-web-interface': ['user-owner-peter'],
    'tech:cloud-infrastructure-azure': ['user-owner-peter'],
    'tech:continuous-integration-and-deployment-pipeline': ['user-owner-peter'],
    'tech:custom-conversational-interface': ['user-owner-peter'],
    'tech:document-management-system-integration': ['user-owner-peter'],
    'tech:document-oriented-database': ['user-owner-peter'],
    'tech:encrypted-transmission': ['user-owner-peter'],
    'tech:blob-storage': ['user-owner-peter'],
    'tech:elasticsearch-logstash-kibana-stack': ['user-owner-peter'],
    'tech:elk-stack': ['user-owner-peter'],
    'tech:azure-openai-service': ['user-owner-peter'],
    'tech:azure-cognitive-services': ['user-owner-peter'],
    'tech:microsoft-graph-api': ['user-owner-peter'],
    'tech:secure-enterprise-sso': ['user-owner-peter'],
};
var normalizePropertyId = function (propertyId) {
    var firstDot = propertyId.indexOf('.');
    if (firstDot < 0) {
        return propertyId;
    }
    var leftPart = propertyId.slice(0, firstDot);
    var rightPart = propertyId.slice(firstDot + 1);
    var leftLooksLikeCategory = leftPart.indexOf(':') < 0;
    return leftLooksLikeCategory ? rightPart : propertyId;
};
exports.getOwnersForMetricsProperty = function (propertyId) {
    var normalizedId = normalizePropertyId(propertyId);
    var ownerIds = PROPERTY_OWNER_IDS_BY_NORMALIZED_ID[normalizedId] || [];
    if (ownerIds.length === 0) {
        return [];
    }
    var usersById = exports.mockUsers.reduce(function (acc, user) {
        acc[user.id] = user;
        return acc;
    }, {});
    return ownerIds
        .map(function (ownerId) { return usersById[ownerId]; })
        .filter(function (user) { return Boolean(user); });
};
exports.getOwnerLabelForMetricsProperty = function (propertyId) {
    var owners = exports.getOwnersForMetricsProperty(propertyId);
    if (owners.length === 0) {
        return 'unassigned';
    }
    if (owners.length === 1) {
        return owners[0].displayName;
    }
    return owners.length + " owners";
};
var GROUP_OWNER_IDS_BY_CATEGORY_ID = {
    unassigned: ['user-gowner-anna'],
    productivity: ['user-gowner-marek'],
};
exports.getGroupOwnerCandidates = function () {
    return exports.mockUsers.filter(function (user) { return user.role === 'group-owner'; });
};
exports.getGroupOwnersForMetricsCategory = function (categoryId) {
    var normalizedId = (categoryId || '').trim().toLowerCase();
    var explicitOwnerIds = GROUP_OWNER_IDS_BY_CATEGORY_ID[normalizedId];
    var ownerIds = explicitOwnerIds
        ? explicitOwnerIds
        : normalizedId.indexOf('benefit') >= 0
            ? ['user-gowner-anna']
            : normalizedId.indexOf('persona') >= 0
                ? ['user-gowner-marek']
                : [];
    if (ownerIds.length === 0) {
        return [];
    }
    var usersById = exports.mockUsers.reduce(function (acc, user) {
        acc[user.id] = user;
        return acc;
    }, {});
    return ownerIds
        .map(function (ownerId) { return usersById[ownerId]; })
        .filter(function (user) { return Boolean(user); });
};
